import { createApi, fetchBaseQuery,  } from "@reduxjs/toolkit/query/react";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const categoryApi = createApi({
  reducerPath: "categoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
      // baseQuery: dynamicBaseQuery,
  tagTypes: ["Category"],
  endpoints: (builder) => ({


    getCategories: builder.query({
      query: () => "/category/getcategories",
      providesTags: ["Category"],
    }),

    addCategory: builder.mutation({
      query: (data) => ({
        url: "/category/addcategory",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),

    updateCategory: builder.mutation({
      query: (data) => ({
        url: "/category/updatecategory",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),

  
    deleteCategory: builder.mutation({
      query: (data) => ({
        url: "/category/deletecategory",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
} = categoryApi;